import { Component, computed, ElementRef, inject, input, output, viewChild } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { ConnectedPosition, Overlay } from '@angular/cdk/overlay';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { RDatasnapResult } from '@cumlaude/service-contract';
import { dutchDate } from '@cumlaude/shared-utils';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { SidebarService } from '@cumlaude/shared-components-overlays';
import { PaginaDelenDialogComponent } from '../../dialogs/pagina-delen/pagina-delen-dialog/pagina-delen-dialog.component';
import { DatasnapUrlService } from '../../services/datasnap-url.service';
import { DatasnapResultSidebarComponent } from '../../sidebars/datasnap/datasnap-result-sidebar.component';
import { LoadingService, LoadingType } from '../../services/loading.service';
import { CssSpinnerComponent } from '../css-spinner/css-spinner.component';

/** Pop-out verschijnt met een schone marge onder de knop, niet erover heen. */
const ONDER_KNOP_POSITIES: ConnectedPosition[] = [
	{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 },
	{ originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: -8 },
];

@Component({
	selector: 'app-dashboard-acties',
	templateUrl: './dashboard-acties.component.html',
	styleUrls: ['./dashboard-acties.component.scss'],
	imports: [AsyncPipe, CssSpinnerComponent, ButtonComponent, IconComponent],
})
export class DashboardActiesComponent {
	private readonly dialog = inject(Dialog);
	private readonly overlay = inject(Overlay);
	protected readonly datasnapUrlService = inject(DatasnapUrlService);
	private readonly sidebarService = inject(SidebarService);
	private readonly loadingService = inject(LoadingService);

	showExportSpinner = this.loadingService.shouldShowLoadingIndicatorSignal(LoadingType.EXPORT);

	readonly shareVisible = input(false);
	readonly exportVisible = input(false);

	exportClicked = output<ElementRef>();

	private readonly delenKnop = viewChild('delenKnop', { read: ElementRef });
	private readonly exporterenKnop = viewChild('exporterenKnop', { read: ElementRef });

	sharePagina() {
		this.dialog.open<void>(PaginaDelenDialogComponent, {
			positionStrategy: this.overlay.position().flexibleConnectedTo(this.delenKnop()!).withPositions(ONDER_KNOP_POSITIES),
		});
	}

	onExportClick() {
		this.exportClicked.emit(this.exporterenKnop()!);
	}

	openHistory(datasnapResults: RDatasnapResult[]) {
		this.sidebarService.open(DatasnapResultSidebarComponent, { data: datasnapResults });
	}

	// als we dit als normale functie in de template aanroepen en de REST-call gaat fout
	// blijft hij re-renderen
	readonly snapshotTitle = computed(() => {
		const key = this.datasnapUrlService.currentSnapshotKey();
		if (key === undefined) return of('');

		return this.datasnapUrlService.getResult(key).pipe(
			map((result) => dutchDate(result.tsRequest)),
			catchError(() => of('[kan snapshot niet laden]'))
		);
	});
}
